// extracted by mini-css-extract-plugin
module.exports = {"container":"PreLoader_container__c7MV-","Two":"PreLoader_Two__1Z7Gh","rotate":"PreLoader_rotate__rHCpH","One":"PreLoader_One__2IXaj"};